/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MessageSchedulePutRequestGeometry
 */
export interface MessageSchedulePutRequestGeometry {
    /**
     * 
     * @type {Array<Array<Array<number>>>}
     * @memberof MessageSchedulePutRequestGeometry
     */
    coordinates?: Array<Array<Array<number>>>;
    /**
     * 
     * @type {string}
     * @memberof MessageSchedulePutRequestGeometry
     */
    type?: string;
}

/**
 * Check if a given object implements the MessageSchedulePutRequestGeometry interface.
 */
export function instanceOfMessageSchedulePutRequestGeometry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MessageSchedulePutRequestGeometryFromJSON(json: any): MessageSchedulePutRequestGeometry {
    return MessageSchedulePutRequestGeometryFromJSONTyped(json, false);
}

export function MessageSchedulePutRequestGeometryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageSchedulePutRequestGeometry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'coordinates': !exists(json, 'coordinates') ? undefined : json['coordinates'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function MessageSchedulePutRequestGeometryToJSON(value?: MessageSchedulePutRequestGeometry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'coordinates': value.coordinates,
        'type': value.type,
    };
}

